export function calculateAnswerScore(answers, choices, defaultKey = "Autre à préciser", logUnmatched = true) {
  const normalize = str => {
    if (typeof str !== "string") return "";

    return str
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/œ/gi, "oe")
      .replace(/æ/gi, "ae")
      .replace(/[’‘`´]/g, "'")
      .replace(/[“”«»]/g, '"')
      .replace(/[–—]/g, "-")
      .replace(/\s+/g, " ")
      .replace(/\u00A0/g, " ")
      .trim()
      .toLowerCase();
  };

  const scoreMap = {};
  choices?.forEach(entry => {
    const [key, value] = Object.entries(entry)[0];
    scoreMap[normalize(key)] = value;
  });

  const defaultScore = scoreMap[normalize(defaultKey)] ?? 0;
  let totalScore = 0;

  const arr = Array.isArray(answers) ? answers : [answers];

  arr.forEach(item => {
    const normItem = normalize(item);
    if (scoreMap[normItem] !== undefined) {
      totalScore += scoreMap[normItem];
    } else {
      totalScore += defaultScore;
    }
  });

  return totalScore;
}